import "reflect-metadata"
import { container, InjectionToken } from "tsyringe"
import { FetchClient } from "@/core/client/fetch_client"
import { FetchSettings } from "@/core/client/fetch_settings"
import { registerClass } from "@/core/generated/api/decorators/serializable_decorator"
import { ResponseModel } from "@/core/generated/api/models/response_model"
import { PagingModel } from "@/core/generated/api/models/paging_model"
import { ContractDetails } from "@/modules/contracts/models/contractDetails"
import { CreateContract } from "@/modules/contracts/models/createContract"
import { ContractBaseModel } from "@/modules/contract/models/contractBaseModel"
import { ExtensionRequestModel } from "@/modules/extension/models/extensionRequestModel"
import { ExtensionConfirmationEmailModel } from "@/modules/extension/models/extensionConfirmationEmailModel"
import { ExtensionOfferModel } from "@/modules/extension/models/extensionOfferModel"
import { SupplierGroup } from "@/modules/spaces/models/supplierGroup_model"
import { TaskSidebarModel } from "@/modules/tasks/models/taskSideBarModel"
import { TaskTemplateListView } from "@/modules/tasks/models/taskTemplateListView"
import { TaskProvider } from "@/modules/tasks/providers/taskProvider"
import { TaskRepository } from "@/modules/tasks/repositories/taskRepository"
import { OpportunityListView } from "@/modules/tasks/supplier/models/opportunityListView"
import { CacheProvider } from "@/shared/cache/cacheProvider"
import { MainTaskSaveArgs } from "@/modules/tasks/models/args/mainTaskSaveArgs"
import { MainTaskModel } from "@/modules/tasks/models/mainTaskModel"
import { ContactModel } from "@/modules/tasks/models/contactModel"
import { ContactExtModel } from "@/modules/tasks/models/contactExtModel"
import { PriceRootModel } from "@/modules/prices/models/priceRootModel"
import { SubAreaModel } from "@/modules/prices/models/subAreaModel"
import { PriceCategoryBaseModel } from "@/modules/prices/models/categories/priceCategoryBaseModel"
import { PriceCategoryFixedModel } from "@/modules/prices/models/categories/priceCategoryFixedModel"
import { PriceCategoryFreeModel } from "@/modules/prices/models/categories/priceCategoryFreeModel"
import { PriceCategoryIntervalModel } from "@/modules/prices/models/categories/priceCategoryIntervalModel"
import { PriceCutModel } from "@/modules/prices/models/priceCutModel"
import { SupplierSubAreaModel } from "@/modules/prices/models/supplierSubAreaModel"
import { FileAttachment } from "@/modules/tasks/customer/models/fileAttachment"
import { SupplierListView } from "@/modules/tasks/supplier/models/supplierListView"
import { SupplierMainTaskPagingModel } from "@/modules/tasks/supplier/models/supplierMainTaskPaging"
import { SupplierMainTaskSelectedPagingModel } from "@/modules/tasks/supplier/models/supplierMainTaskSelectedPaging"
import { SupplierSelectionTaskListView } from "@/modules/tasks/supplier/models/supplierSelectionTaskListView"
import { SupplierTaskListView } from "@/modules/tasks/supplier/models/supplierTaskListView"
import { UserListView } from "@/modules/tasks/models/userListView"
import { RFQTaskModel } from "@/modules/tasks/models/rfqTaskModel"
import { CustomerListView } from "@/modules/tasks/customer/models/customerListView"
import { CustomerMainTaskListView } from "@/modules/tasks/customer/models/customerMainTaskListView"
import { CustomerMainTaskSimpleListView } from "@/modules/tasks/customer/models/customerMainTaskSimpleListView"
import { CustomerTaskListView } from "@/modules/tasks/customer/models/customerTaskListView"
import { SimpleModel } from "@/modules/minibids/models/simpleModel"
import { MinibidTask } from "@/modules/minibids/models/minibidTask"
import { AssignedContact } from "@/modules/minibids/models/assignedContacts"
import { LeadTaskListView } from "@/modules/lead/models/leadTaskListView"
import { LeadResponsibleModel } from "@/modules/lead/models/leadResponsibleModel"
import { ContactUser } from "@/modules/tasks/models/contactUser"
import { LeadNoteModel } from "@/modules/lead/models/leadNoteModel"
import { LeadTaskModel } from "@/modules/lead/models/leadTaskModel"
import { LeadReviewTaskListView } from "@/modules/lead/models/leadReviewTaskListView"
import { LeadConvertModel } from "@/modules/lead/models/leadConvertModel"
import { UserListViewSpace } from "@/modules/users/models/userListViewSpace"
import { CandidateMatchModel } from "@/modules/tasks/models/match/candidateMatchModel"
import { MatchModel } from "@/modules/tasks/models/match/matchModel"
import { MatchArgs } from "@/modules/tasks/models/args/matchArgs"
import { CandidateModel } from "@/modules/candidate/models/candidateModel"
import { ListModel } from "@/core/generated/api/models/list_model"
import { UserModel } from "@/modules/users/models/userModel"
import { SupplierProposalModel } from "@/modules/tasks/supplier/models/supplierProposalModel"
import { ProposalBaseModel } from "@/modules/tasks/models/proposalBaseModel"
import { TaskNoteModel } from "@/modules/tasks/models/taskNoteModel"
import { ProposalAnalyticModel } from "@/modules/tasks/models/proposalAnalyticModel"
import { PriceAdjustmentArgs } from "@/modules/prices/models/args/priceAdjustmentArgs"
import { PriceLogBaseModel } from "@/modules/prices/models/log/priceLogBaseModel"
import { PriceLogAdjustmentModel } from "@/modules/prices/models/log/priceLogAdjustmentModel"
import { PriceLogChangeModel } from "@/modules/prices/models/log/priceLogChangeModel"
import { PriceLogPagingModel } from "@/modules/prices/models/args/priceLogPagingModel"
import { UserValidName } from "@/modules/users/models/userValidName"
import { RFSConsultantModel } from "@/modules/tasks/models/rfs/rfsConsultantModel"
import { HiringLocation } from "@/modules/tasks/models/rfs/hiringLocation"
import { OnboardingRequirementModel } from "@/modules/tasks/models/rfs/onboardingRequirementModel"
import { SupplierLocationListView } from "@/modules/tasks/supplier/models/supplierLocationListView"
import { ApproverCostModel } from "@/modules/tasks/models/rfs/approverCostModel"
import { AgreementSelectorView } from "@/modules/tasks/customer/models/agreementSelectorView"
import { CurrencyConversionArgs } from "@/modules/prices/models/args/currencyConversionArgs"
import { CurrencyConversionModel } from "@/modules/prices/models/currencyConversionModel"
import { RFSContractorModel } from "@/modules/tasks/models/rfs/rfsContractorModel"
import { RFSTrygExtended } from "@/modules/tasks/models/rfs/rfsTrygExtended"
import { CostCenterModel } from "@/modules/tasks/models/rfs/costCenterModel"
import { RFQExtended } from "@/modules/tasks/models/args/rfqExtended"
import { CompanyListModel } from "@/modules/company/models/companyListModel"
import { ActivityEventItem } from "@/modules/activity/models/activityEventItem"
import { CandidateListView } from "@/modules/candidate/models/candidateListView"
import { CandidateAllocationPeriod } from "@/modules/candidate/models/candidateAllocationPeriod"

export const useStartup = () => {
  container.register(FetchSettings, { useClass: FetchSettings })
  container.register(FetchClient, {
    useValue: new FetchClient(getService(FetchSettings)),
  })

  container.register(TaskRepository, {
    useValue: new TaskRepository(getService(FetchClient)),
  })
  container.register(TaskProvider, {
    useValue: new TaskProvider(
      getService(CacheProvider),
      getService(TaskRepository),
    ),
  })

  registerClass(ListModel)
  registerClass(ResponseModel)
  registerClass(PagingModel)
  registerClass(TaskSidebarModel)
  registerClass(TaskTemplateListView)
  registerClass(OpportunityListView)
  registerClass(ContractDetails)
  registerClass(CreateContract)
  registerClass(ContractBaseModel)
  registerClass(ExtensionRequestModel)
  registerClass(ExtensionOfferModel)
  registerClass(ExtensionConfirmationEmailModel)
  registerClass(SupplierGroup)
  registerClass(MainTaskSaveArgs)
  registerClass(MainTaskModel)
  registerClass(ContactModel)
  registerClass(ContactExtModel)
  registerClass(PriceRootModel)
  registerClass(SubAreaModel)
  registerClass(PriceCategoryBaseModel)
  registerClass(PriceCategoryFixedModel)
  registerClass(PriceCategoryFreeModel)
  registerClass(PriceCategoryIntervalModel)
  registerClass(PriceCutModel)
  registerClass(SubAreaModel)
  registerClass(SupplierSubAreaModel)
  registerClass(FileAttachment)
  registerClass(SupplierListView)
  registerClass(SupplierMainTaskPagingModel)
  registerClass(SupplierMainTaskSelectedPagingModel)
  registerClass(SupplierSelectionTaskListView)
  registerClass(SupplierTaskListView)
  registerClass(RFQTaskModel)
  registerClass(CustomerListView)
  registerClass(CustomerMainTaskListView)
  registerClass(CustomerMainTaskSimpleListView)
  registerClass(CustomerTaskListView)
  registerClass(SimpleModel)
  registerClass(AssignedContact)
  registerClass(MinibidTask)
  registerClass(LeadTaskListView)
  registerClass(LeadResponsibleModel)
  registerClass(ContactUser)
  registerClass(UserListView)
  registerClass(UserListViewSpace)
  registerClass(LeadReviewTaskListView)
  registerClass(LeadTaskModel)
  registerClass(LeadNoteModel)
  registerClass(LeadConvertModel)
  registerClass(MatchArgs)
  registerClass(CandidateMatchModel)
  registerClass(MatchModel)
  registerClass(UserModel)
  registerClass(CandidateModel)
  registerClass(ProposalBaseModel)
  registerClass(SupplierProposalModel)
  registerClass(TaskNoteModel)
  registerClass(ProposalAnalyticModel)
  registerClass(PriceAdjustmentArgs)
  registerClass(PriceLogBaseModel)
  registerClass(PriceLogAdjustmentModel)
  registerClass(PriceLogChangeModel)
  registerClass(PriceLogPagingModel)
  registerClass(UserValidName)
  registerClass(HiringLocation)
  registerClass(OnboardingRequirementModel)
  registerClass(RFSConsultantModel)
  registerClass(RFSContractorModel)
  registerClass(SupplierLocationListView)
  registerClass(ApproverCostModel)
  registerClass(AgreementSelectorView)
  registerClass(CurrencyConversionArgs)
  registerClass(CurrencyConversionModel)
  registerClass(RFQExtended)
  registerClass(CostCenterModel)
  registerClass(RFSTrygExtended)
  registerClass(CompanyListModel)
  registerClass(ActivityEventItem)
  registerClass(CandidateListView)
  registerClass(CandidateAllocationPeriod)
}

export const getService = <T>(token: InjectionToken<T>): T => {
  return container.resolve(token)
}
